import makeStyles from '@mui/styles/makeStyles';

export const useListStyles = makeStyles((theme) => {
  return {
    listRoot: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: 0,
    },
    listItemRoot: {
      color: theme.palette.primary.main,
      maxHeight: 25,
      padding: '0 10px',
      whiteSpace: 'nowrap',
      '& .MuiListItemIcon-root': {
        minWidth: 36,
      },

      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
        textDecoration: 'underline solid black 1px',
        textUnderlinePosition: 'under',
      },
      '& :hover': {
        color: 'rgba(0,0,0,0.5)',
      },
    },
    listItemSelected: {
      backgroundColor: `${theme.palette.secondary.main} !important`,
      textDecoration: 'underline solid black 2px',
      textUnderlinePosition: 'under',
    },
    listItemButton: {
      padding: 0,
      marginRight: 10,
    },
  };
});
